import React, { useState } from 'react';
import { Button, RadioGroup } from '../UI';
import { kuesionerData } from '../../helpers/kuesioner';
import { calculateAgeMonths } from '../../helpers/utils';
import { getAssessmentRecommendations } from '../../helpers/assessmentRecommendations';

export default function MentalForm({ child, onSave }) {
    const ageInMonths = calculateAgeMonths(child.dob.toDate());
    // Filter questions relevant for the child's age
    const relevantQuestions = kuesionerData.kmme.filter(q => ageInMonths >= q.age);
    const [answers, setAnswers] = useState({});
    const [loading, setLoading] = useState(false);

    const handleAnswer = (index, value) => {
        setAnswers(prev => ({ ...prev, [index]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Object.keys(answers).length < relevantQuestions.length) {
            alert("Harap jawab semua pertanyaan.");
            return;
        }
        setLoading(true);
        const score = Object.values(answers).filter(v => v === 'Ya').length;
        const total = relevantQuestions.length;
        
        const recommendations = getAssessmentRecommendations('kmme', score, total, ageInMonths);
        
        const data = { 
            mental: { 
                status: recommendations.status, 
                interpretasi: recommendations.interpretation,
                rekomendasi: recommendations.recommendations.join('\n• '),
                tindakLanjut: recommendations.followUp,
                tingkatUrgency: recommendations.urgency,
                detail: `Skor KMME: ${score}/${total}` 
            } 
        };
        onSave(data, recommendations.status);
    };

    const yesNoOptions = [
        { value: 'Ya', label: 'Ya', emoji: '✅' },
        { value: 'Tidak', label: 'Tidak', emoji: '❌' }
    ];

    if (relevantQuestions.length === 0) {
        return (
            <div className="text-center p-8 bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl">
                <span className="text-4xl mb-4 block">🧠</span>
                <p className="text-gray-600 font-medium">Tidak ada kuesioner Mental Emosional yang relevan untuk usia anak saat ini.</p>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-6 rounded-2xl border border-purple-200">
                <div className="flex items-center space-x-3 mb-2">
                    <span className="text-2xl">🧠</span>
                    <h3 className="font-bold text-purple-800">Kuesioner Mental Emosional (KMME)</h3>
                </div>
                <p className="text-purple-700 text-sm">Jawab berdasarkan perilaku anak dalam 6 bulan terakhir.</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                {relevantQuestions.map((item, index) => (
                    <div key={index} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                        <div className="mb-4">
                            <span className="inline-flex items-center justify-center w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full text-sm font-bold mr-3">
                                {index + 1}
                            </span>
                            <label className="text-gray-800 font-medium text-base leading-relaxed">{item.q}</label>
                        </div>
                        <RadioGroup
                            name={`mental-${index}`}
                            options={yesNoOptions}
                            value={answers[index] || ''}
                            onChange={(value) => handleAnswer(index, value)}
                        />
                    </div>
                ))}
                <Button type="submit" disabled={loading} className="mt-8">
                    {loading ? '🔄 Menyimpan...' : '💾 Simpan Hasil Mental Emosional'}
                </Button>
            </form>
        </div>
    );
}
